import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';

const API_BASE_URL = `${process.env.REACT_APP_URL}/api/roles`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("tokenInv");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  };
};

export const fetchRoles = async () => {
  try {
    const response = await axios.get(API_BASE_URL, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (err) {
    console.error("Caught inside fetchRoles:", err); 
    // toast.error(err.response?.data?.error || "Something went wrong");
    throw err;
  }
};


export const addRole = async (roleData) => {
  const response = await axios.post(API_BASE_URL, roleData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const deleteRole = async (roleId) => {
  const response = await axios.delete(`${API_BASE_URL}/${roleId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};
